export const SLOWEST_ITEMS_CARD_GRID_TEMPLATE =
  "minmax(0, 1.8fr) minmax(var(--size-64), 1fr) var(--size-64)";
